<template>
  <header id="header" class="uk-light"
          v-if="welcome.list"
  >
    <div v-for="w in welcome.list" v-bind:key="w.id">

        <div id="title" class="uk-background-cover header-full-height"
             v-for="(v, idx) in w.image[0].variations" v-bind:key="'titleImage-' + idx" v-if="v.width === 1920"
             v-bind:style="'background-image: url(' + v.httpUrl + ');'"
        >
          <div class="uk-container uk-container-large uk-position-relative">
            <div id="logo-container">
              <img id="logo"
                   class="uk-preserve"
                   src="/static/logo.svg"
                   width="234"
                   height="185"
                   alt="Seelsorgeeinheit Freiburg Mitte"
                   data-uk-svg>
            </div>
          </div>
          <transition v-on:enter="enter"
                      v-on:leave="leave"
          >
            <div v-show="headerFull" class="uk-position-relative">
              <div id="title-gradient" class="uk-position-bottom-center"></div>
              <div id="welcome" class="uk-container uk-container-large uk-position-relative header-full-height">
                <div class="uk-position-bottom-center uk-padding-large"
                     v-if="$route.path === '/'"
                >
                  <div data-uk-grid>
                    <div class="uk-width-1-5 uk-width-2-6@s uk-width-1-6@m">
                      <img id="title-pfeifen" class="uk-align-left" src="/static/pfeifen-blau.svg" alt="Orgelpfeifen"
                           data-uk-svg>
                    </div>
                    <div class="uk-width-4-5 uk-width-4-6@s uk-width-5-6@m">
                      <h1 class="uk-leader">{{w.headline}}</h1>
                      <h2 class="uk-text-capitalize uk-margin-remove-bottom">{{w.subheadline_one.toUpperCase()}}</h2>
                      <h3 class="uk-text-capitalize uk-margin-remove-bottom">{{w.subheadline_two.toUpperCase()}}</h3>
                    </div>
                  </div>
                  <div id="button-container" class="uk-flex uk-flex-column uk-margin-medium-top">
                    <router-link to="/pate-werden"
                                 class="uk-button uk-button-default uk-button-large uk-text-large uk-light uk-align-center">
                      {{w.button_text_one}}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
    </div>
  </header>
</template>
<script>
import {WELCOME} from '../../constants/graphql'
import {Power2, TimelineMax} from 'gsap'

export default {
  name: 'site-header',
  data () {
    return {
      welcome: {},
      headerFull: true,
      animateHeaderTl: undefined
    }
  },
  apollo: {
    welcome: {
      query: WELCOME
    }
  },
  computed: {
    headerClass () {
      return this.$route.path === '/' ? 'header-full-height' : 'header-minimized-height'
    }
  },
  methods: {
    enter () {
      if (typeof this.animateHeaderTl === 'object') {
        this.animateHeaderTl.tweenTo('full')
      }
    },
    leave () {
      if (typeof this.animateHeaderTl === 'object') {
        this.animateHeaderTl.tweenTo('minimized')
      }
    }
  },
  mounted () {
    this.headerFull = this.$route.path === '/'
  },
  updated: function () {
    if (typeof this.animateHeaderTl === 'undefined') {
      this.animateHeaderTl = new TimelineMax({
        paused: true
      })
      this.animateHeaderTl
        .add('minimized')
        .set(document.getElementById('title'), {className: '+=header-minimized-height'})
        .fromTo(document.getElementById('title'), 2, {'min-height': '30vh'}, {'min-height': '100vh', ease: Power2.easeInOut})
        .fromTo(document.getElementById('welcome'), 2, {'min-height': '30vh'}, {'min-height': '100vh', ease: Power2.easeInOut}, '-=2')
        .fromTo(document.getElementById('title-gradient'), 2, {'min-height': '30vh', autoAlpha: 0}, {'min-height': '100vh', autoAlpha: 1, ease: Power2.easeInOut}, '-=2')
        .set(document.getElementById('title'), {className: '-=header-minimized-height'})
        .add('full')

      if (this.headerFull) {
        this.animateHeaderTl.tweenTo('full')
      } else {
        this.animateHeaderTl.tweenTo('minimized')
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.headerFull = to.path === '/'
    },
    headerFull (newVal, oldVal) {
      if (typeof this.animateHeaderTl !== 'undefined') {
        if (this.headerFull) {
          this.animateHeaderTl.tweenTo('full')
        } else {
          this.animateHeaderTl.tweenTo('minimized')
        }
      }
    }
  }
}
</script>
<style lang="scss">
  @import "~uikit/src/scss/variables-theme";
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  #header {

    transition: background-size 0.3s;

    @for $i from 1 through 6 {
      h#{$i} {
        font-family: $font-book;
      }
    }
    .uk-background-cover {
      background-size: cover;
      transition: background-size 0.6s, background-position-x 0.6s;
      &.header-full-height {
        min-height: 100vh;
        background-position-x: 43%;
        @media (min-width: $breakpoint-small) {
          background-position-x: 45%;
        }
        @media (min-width: $breakpoint-medium) {
          background-position-x: 45%;
        }
      }
      &.header-minimized-height {
        min-height: 30vh;
        @media (min-width: $breakpoint-small) {
          background-size: 200%;
          background-position-x: 45%;
        }
        @media (min-width: $breakpoint-medium) {
          background-size: 200%;
          background-position-x: 45%;
        }
        @media (min-width: $breakpoint-large) {
          background-size: 150%;
        }
        @media (min-width: $breakpoint-xlarge) {
          background-size: 100%;
        }
      }
    }
    #logo-container {
      position: absolute;
      top: 1em;
      right: 50%;
      z-index: 1000;
      transform: translateX(50%);
      width: 8em;
      @media (min-width: $breakpoint-small) {
        width: 15em;
        top: 2em;
        right: 2em;
        transform: translateX(0);
      }
      @media screen and (orientation: landscape) {
        width: 8em;
        top: 1em;
        right: 2em;
      }
      @media screen and (orientation: portrait) {
        width: 10em;
        top: 3em;
      }
      @media (min-width: $breakpoint-medium) {
        width: 20em;
        top: 2em;
        right: 2em;
      }
    }
    #button-container {
      .uk-button {
        white-space: nowrap;
        &.uk-button-large {
          padding: calculateRem(8px) calculateRem(60px);
          @media (min-width: $breakpoint-small) {
            padding: calculateRem(8px) calculateRem(100px);
          }
        }
        @media screen and (orientation: landscape) {
          margin-bottom: 0;
        }
        @media (min-width: $breakpoint-medium) {
          margin-bottom: $margin-large-margin;
        }
      }
      @media screen and (orientation: landscape) {
        margin-top: 1em!important;
      }
      @media (min-width: $breakpoint-medium) {
        margin-top: 3em;
      }
    }
  }

  #welcome {
    h1 {
      @include fontSize(50px);
      line-height: 1.0;
      @media (min-width: $breakpoint-small) {
        @include fontSize(80px);
        line-height: 1.1;
      }
      @media screen and (orientation: landscape) {
        @include fontSize(42px);
        line-height: 1.0;
        margin-bottom: 0;
      }
      @media (min-width: $breakpoint-medium) {
        @include fontSize(60px);
        line-height: 1.2;
      }
    }
    h2 {
      font-family: $font-heavy;
      @include fontSize(20px);
      line-height: 1.1;
      @media (min-width: $breakpoint-small) {
        @include fontSize(35px);
        line-height: 1.2;
      }
      @media screen and (orientation: landscape) {
        @include fontSize(20px);
        line-height: 1.1;
        margin-top: 1em;
      }
      @media (min-width: $breakpoint-medium) {
        @include fontSize(35px);
        line-height: 1.2;
      }
    }
    h3 {
      @include fontSize(20px);
      margin-top: calculateRem(10px);
      line-height: 1.1;
      @media (min-width: $breakpoint-small) {
        @include fontSize(35px);
        margin-top: 0;
        line-height: 1.1;
      }
      @media screen and (orientation: landscape) {
        @include fontSize(20px);
        line-height: 1.1;
      }
      @media (min-width: $breakpoint-medium) {
        @include fontSize(35px);
        line-height: 1.2;
      }
    }
    & > div {
      height: 300px;
      margin-bottom: 2em;
      @media (min-width: $breakpoint-small) {
        height: 200px;
        margin-bottom: 2em;
      }
      @media screen and (orientation: landscape) {
        padding-bottom: 1em;
      }
      [data-uk-grid] {
        .uk-first-column {
          position: relative;
          #title-pfeifen {
            position: absolute;
            max-width: 80%;
            @media screen and (orientation: landscape) {
              max-width: 60%;
            }
            @media (min-width: $breakpoint-medium) {
              max-width: 80%;
            }
            height: auto;
            bottom: 0;
          }
          & + div {
            h1, h2, h3 {
              @media screen and (orientation: landscape) {
                width: 70%;
              }
              @media (min-width: $breakpoint-medium) {
                width: unset;
              }
            }
          }
        }
        margin-bottom: 3em;
        @media screen and (orientation: landscape) {
          margin-bottom: 2em;
        }
        @media (min-width: $breakpoint-medium) {
          margin-bottom: $margin-large-margin;
        }
      }
    }
  }

  #title-gradient {
    width: 100vw;
    height: 50vh;
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(84, 84, 84, 1) 100%);
    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(84, 84, 84, 1) 100%);
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(84, 84, 84, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#545454', GradientType=0);
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/SiteHeader.vue